import { useState } from "react";
import { StockForm } from "./StockForm";
import { StockTable } from "./StockTable";
import { Button } from "./ui/button";
import { Plus } from "lucide-react";

export function StockManagement() {
  const [showStockForm, setShowStockForm] = useState(false);

  return (
    <div className="w-full">
      <div className="max-w-[95%] sm:max-w-[90%] md:max-w-7xl mx-auto space-y-3 sm:space-y-4 md:space-y-6">
        <div className="flex justify-between items-center mb-4 md:mb-6">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold">Controle de Estoque</h2>
          <Button onClick={() => setShowStockForm(true)} className="bg-white text-background hover:bg-gray-100">
            <Plus className="h-4 w-4 mr-2" />
            Novo Item
          </Button>
        </div>

        {showStockForm && (
          <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50">
            <div className="fixed inset-x-4 top-4 bottom-4 md:inset-x-[20%] md:top-[10%] md:bottom-[10%] bg-card rounded-lg shadow-lg p-6 overflow-auto">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold">Cadastro de Item</h2>
                <button
                  onClick={() => setShowStockForm(false)}
                  className="text-muted-foreground hover:text-foreground"
                >
                  ✕
                </button>
              </div>
              <StockForm onClose={() => setShowStockForm(false)} />
            </div>
          </div>
        )}

        <StockTable />
      </div>
    </div>
  );
}